import React, { useEffect } from 'react';
import { Box, Stack, Typography } from '@mui/joy';
import CongressImg from '../congress-vector.png';
import './Bills/Bills.css';


const statistics = [
    {
        quote: `Over 10,000 bills are introduced in Congress every year.
      Stay informed about the ones that matter most to you. 
      Your voice can help shape the future of these policies.`,
        source: 'Congress.gov',
    },
    {
        quote: `Email campaigns show a substantial influence, up to 20%, on legislative voting behavior. 
      Your representatives are here to serve you—let’s connect you with them.`,
        source: 'Bergan, D. E. (2009)',
    },
    {
        quote: `Only 1/3 of Americans know their Representative's name. 
      We’re making it easier than ever for you to advocate for the issues you care about.`,
        source: 'Haven Insights',
    },
    {
        quote: `Only 29% of Americans currently approve of the way Congress is handling its job.
      Let them know which polices you care about most.`,
        source: 'Gallup Polls',
    },
    {
        quote: `Less than 10% of bills introduced in Congress become law. 
      Understanding the details is the first step to making an impact.`,
        source: 'USHistory.org',
    },
];

function Loading() {
    var statisticsTracker = 0;
    const [statistic, setStatistic] = React.useState(statistics[0]);

    useEffect(() => {
        var statisticsInterval = setInterval(() => {
            if (statisticsTracker >= statistics.length - 1) {
                statisticsTracker = 0;
                setStatistic(statistics[statisticsTracker]);
            } else {
                statisticsTracker = statisticsTracker + 1;
                setStatistic(statistics[statisticsTracker]);
            }
        }, 10000);

        return () => {
            clearInterval(statisticsInterval);
        };
    }, []);

    return (
        <Stack
        className="loading-container"
        direction={"column"}
        padding={2}
        spacing={2}
        sx={{
          alignItems: "center",
          justifyContent: "center",
        }}>
            <img src={CongressImg} alt={'congress decorative'} width="300" height="300" />
            <Box className="loading-title">
                <Typography
                    level="h1"
                    color="primary"
                    sx={{ textAlign: 'center' }}
                >
                    Get ready to explore the latest legislation and take action.
                </Typography>
                <Typography
                    className="statistics"
                    level="title-md"
                    sx={{ marginTop: 2, textAlign: 'center' }}
                >
                    {statistic.quote}
                </Typography>
                <Typography
                    className="statistics"
                    level="body-md"
                    sx={{ marginTop: 2, textAlign: 'center' }}
                >
                    &mdash; {statistic.source}
                </Typography>
            </Box>
            <div className="loader"></div>
        </Stack>
    );
}

export default Loading;
